import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";

const FaqItem = ({ faq, isOpen, onToggle }) => {
  return (
    <div className="border-b border-gray-200 last:border-b-0">
      {/* Heading */}
      <button
        onClick={onToggle}
        className={`w-full flex justify-between items-center px-5 py-3 text-left transition-colors
          ${isOpen ? "bg-orange-500 text-white" : "bg-white text-[#9d2e43]"}
        `}
      >
        {/* Title */}
        <span className="pr-3 text-[14px] md:text-[16px] font-semibold">{faq.title}</span>

        {/* Icon */}
        {isOpen ? (
          <ChevronUp size={24} className="text-white" />
        ) : (
          <ChevronDown size={24} className="text-orange-500" />
        )}
      </button>

      {/* Answer */}
      {isOpen && (
        <div className="px-5 pb-8 pt-4 bg-[#fae8dc]">
          <p className=" text-[16px] md:text-[18px] text-gray-800 leading-relaxed text-start">
            {faq.answer}
          </p>
        </div>
      )}
    </div>
  );
};

export default FaqItem;
